import styled from 'styled-components';

export const TextWrapper = styled.div`
  text-align: center;
`;
export const ElementsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  text-align: center;
  @media ${({ theme }) => theme.media.tablet} {
    flex-direction: row;
  }
`;

export const IconsWrapper = styled.div`
  padding: 10px;
  margin-top: 15px;
  /* box-shadow: 1px 9px 33px -15px rgba(66, 68, 90, 1); */
  /* border-radius: 20px; */

  img {
    height: 50px;
  }

  @media ${({ theme }) => theme.media.tablet} {
    margin: 10px;
    width: 50%;
  }
  @media ${({ theme }) => theme.media.laptop} {
    width: 20%;
  }
`;
